import * as React from "react"
import {Box} from "@mui/material"
import {ImageSeeker} from "@ui-seeker/core"

import {CheckIcon} from "../@components"


export default function ProductPagesImagesDetailImagesBlock({ images, selected, selectedCatalogue, showIcon }) {
	return <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
		{images.map(({ url, imageCheckerID, similarity, compareSimilarity, checkStatus }, idx) => <ImageBlock
			key={idx}
			idx={idx}
			url={url}
			selected={selected}
			selectedCatalogue={selectedCatalogue}
			imageCheckerID={imageCheckerID}
			similarity={similarity}
			compareSimilarity={compareSimilarity}
			showIcon={showIcon}
			checkStatus={checkStatus}
		/>)}
	</Box>
}

const ImageBlock = ({ idx, url, selected, selectedCatalogue, imageCheckerID, similarity, checkStatus }) => {
	return <Box sx={{ position: 'relative', display: 'inline-block' }}>
		<ImageSeeker
			src={url}
			onClick={() => {
				selected.value = idx
				selectedCatalogue.value = imageCheckerID
			}}
			sx={{
				width: 50, height: 50, cursor: "pointer",
				...selected.value === idx && { border: "3px solid", borderColor: "info.main" }
			}}
		/>
		<CheckIcon
			show={similarity !== null}
			status={checkStatus}
		/>
	</Box>
}